"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doesCommandGenerateReceipt = void 0;
const enums_1 = require("../enums");
const command_source_1 = require("./command-source");
const doesCommandGenerateReceipt = ({ command, formReceiptSettings, shouldGenerateReceiptForManualEntry, isPaymentReceived = false, }) => {
    if (command.paymentMethod === enums_1.PaymentMethod.Daf) {
        return false;
    }
    const isManualCommand = (0, command_source_1.isManualCommandSource)(command.source);
    const isTapToPayManualCommand = command.paymentMethod === enums_1.PaymentMethod.InPersonCash;
    const isFormSubmissionCommand = command.source === enums_1.CommandSource.FormSubmission;
    if (formReceiptSettings && !formReceiptSettings.generatesReceipt) {
        return false;
    }
    const isChequeAwaitingPayment = command.paymentMethod === enums_1.PaymentMethod.Cheque && !isPaymentReceived;
    if (isFormSubmissionCommand && (isChequeAwaitingPayment || command.eligibleAmount < 1)) {
        return false;
    }
    if (command.eligibleAmount <= 0 && command.paymentMethod !== enums_1.PaymentMethod.InKind) {
        return false;
    }
    const isWebManualCommand = isManualCommand && !isTapToPayManualCommand;
    if (isWebManualCommand && !shouldGenerateReceiptForManualEntry) {
        return false;
    }
    return true;
};
exports.doesCommandGenerateReceipt = doesCommandGenerateReceipt;
